import { frontendURL } from '../../../helper/URLHelper';
import KanbanPipelinesIndex from './pages/KanbanPipelinesIndex.vue';
import KanbanBoardIndex from './pages/KanbanBoardIndex.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.KANBAN,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_pipelines_index',
    component: KanbanPipelinesIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:pipelineId'),
    name: 'kanban_board',
    component: KanbanBoardIndex,
    meta: commonMeta,
  },
];
